import { defineMessages } from "react-intl";

const messages = defineMessages({
    cropScore: {
        id: "tasks.barSorting.cropScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    loading: {
        id: "general.loading",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
});


export default messages;
